<template>
  <v-container class="AssignmentDetailsPage">
    <SchoolTitleBar :title="loading ? 'Loading...' : assignmentTitle" />

    <div
      v-if="loading"
      class="d-flex justify-center pa-5"
    >
      <v-progress-circular
        indeterminate
        size="60"
      />
    </div>
    <template v-else-if="assignment">
      <AssignmentDetailsInfo
        v-if="assignment"
        :assignment="assignment"
        class="my-7"
      />
      <AssignmentTestReports
        v-if="assignment"
        :assignment="assignment"
        class="pb-5"
      />
    </template>
    <div v-else class="d-flex justify-center pa-5">
      <h5 class="text-h5 red--text">Assignment not found (404)</h5>
    </div>

    <AssignmentDetailsBottomToolbar
      :assignment="assignment"
      :test-loading="testLoading"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { handleReqErrorWithToast } from '@/helpers/error-handlers';

let tickTimersInterval = null;

export default {
  name: 'AssignmentDetailsPage',
  components: {
    SchoolTitleBar: () => import('@/components/profiles/SchoolTitleBar'),
    AssignmentDetailsInfo: () => import('@/components/assignments/AssignmentDetailsInfo'),
    AssignmentTestReports: () => import('@/components/assignments/AssignmentTestReports'),
    AssignmentDetailsBottomToolbar: () => import('@/components/assignments/AssignmentDetailsBottomToolbar'),
  },
  data() {
    return {
      loading: false,
      finishAssignmentError: null,
    };
  },
  computed: {
    ...mapGetters('assignments', [
      'assignments',
      'testsLoading',
      'overdueTimerAssignments',
    ]),
    routeAssignmentId() {
      return this.$route.params.assignmentId;
    },
    assignment() {
      return this.assignments.find(a => a._id === this.routeAssignmentId);
    },
    assignmentId() {
      return this.assignment?._id;
    },
    assignmentTitle() {
      if (this.assignment) {
        return this.$vuetify.breakpoint.xsOnly
          ? this.assignment.name : `ASSIGNMENT: ${this.assignment.name}`;
      }
      return null;
    },
    isOverdueTimer() {
      return this.overdueTimerAssignments.some(a => a._id === this.assignmentId);
    },
    testLoading() {
      return this.testsLoading[this.assignmentId];
    },
  },
  created() {
    this.loadAssignmentInfo();
  },
  mounted() {
    tickTimersInterval = setInterval(this.onTestTimerIntervalTick, 1000);
  },
  beforeDestroy() {
    clearInterval(tickTimersInterval);
  },
  methods: {
    ...mapActions('assignments', [
      'loadAssignment',
      'tickTestsTimer',
      'finishAssignmentTest',
    ]),
    loadAssignmentInfo() {
      this.loading = true;
      this.loadAssignment({ assignmentId: this.routeAssignmentId })
        .then(() => this.tickTestsTimer())
        .catch(err => handleReqErrorWithToast(err, 'Failed to load assignment info'))
        .finally(() => (this.loading = false));
    },
    onTestTimerIntervalTick() {
      this.tickTestsTimer();

      if (this.isOverdueTimer && !this.testLoading && !this.finishAssignmentError) {
        this.finishAssignmentTest({ assignmentId: this.assignmentId })
          .catch(err => (this.finishAssignmentError = err));
      }
    },
  },
};
</script>
